import { Component, Input, Output, EventEmitter, OnChanges, AfterViewInit, ViewChild, TemplateRef, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { ApproverService } from '../../../core/services/approver.service';

@Component({
  selector: 'app-approver-table',
  templateUrl: './approver-table.component.html',
  styleUrls: ['./approver-table.component.scss']
})
export class ApproverTableComponent implements OnChanges, AfterViewInit {

  @Input() activityId: any;
  @Input() size: number = 5;
  @Input() reloadTrigger: number = 0;

  @Output() openApprove = new EventEmitter<any>();
  @Output() openReject = new EventEmitter<any>();
  @Output() openChat = new EventEmitter<any>();

  @ViewChild('partnerNameTpl') partnerNameTpl!: TemplateRef<any>;
  @ViewChild('submittedOnTpl') submittedOnTpl!: TemplateRef<any>;
  @ViewChild('updatedOnTpl') updatedOnTpl!: TemplateRef<any>;
  @ViewChild('proofTpl') proofTpl!: TemplateRef<any>;
  @ViewChild('statusTpl') statusTpl!: TemplateRef<any>;
  @ViewChild('chatTpl') chatTpl!: TemplateRef<any>;

  tableColumns: DataTableColumn[] = [];
  approvalStatusOptions = [
    { id: 'PENDING_APPROVAL', name: 'Pending Approval' },
    { id: 'APPROVED', name: 'Approved' },
    { id: 'REJECTED', name: 'Rejected' },
  ];
  selectedApprovalStatusItem: any = null;
  approverList: any = null;
  page = 1;
  partnerName = '';
  partnerUser = '';
  category = '';
  approverEmail = '';
  approvalStatus = '';
  searchDiv = false;
  searchCount = 0;
  closeIconFlag = false;

  constructor(
    private approverService: ApproverService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activityId'] && this.activityId) {
      this.page = 1;
      this.clearSearch();
      this.loadData();
    }
    if (changes['reloadTrigger'] && !changes['reloadTrigger'].firstChange) {
      this.loadData();
    }
  }

  ngAfterViewInit() {
    if (this.tableColumns.length === 0) {
      this.tableColumns = [
        { field: 'partnerName', header: 'Partner Name', cellTemplate: this.partnerNameTpl },
        { field: 'partnerUser', header: 'Partner User' },
        { field: 'documentType', header: 'Category' },
        { field: 'email', header: 'Email' },
        { field: 'submittedOn', header: 'Submitted On', cellTemplate: this.submittedOnTpl },
        { field: 'statusUpdatedOn', header: 'Updated On', cellTemplate: this.updatedOnTpl },
        { field: 'proofOfCompletion', header: 'Proof of Performance', cellTemplate: this.proofTpl },
        { field: 'status', header: 'Approval Status', cellTemplate: this.statusTpl },
        { field: 'chat', header: '', cellTemplate: this.chatTpl },
      ];
    }
    this.cdr.detectChanges();
  }

  loadData() {
    if (this.partnerName || this.partnerUser || this.category || this.approverEmail || this.approvalStatus) {
      this.runSearch();
    } else {
      const req = '?activityChallengeId=' + this.activityId + '&page=' + (this.page - 1) + '&size=' + this.size;
      this.approverService.getActivityGridData(req).subscribe((res) => {
        if (res) {
          this.approverList = res;
        }
      }, (error) => {
        console.log(error);
      });
    }
  }

  onPageChange(eve: any) {
    this.page = eve;
    this.loadData();
  }

  onApprovalStatusChange(item: any) {
    this.approvalStatus = item ? item.id : '';
    this.selectedApprovalStatusItem = item;
  }

  onSearch() {
    if (this.searchCount === 0) {
      this.searchDiv = true;
      this.searchCount++;
    } else {
      if (this.partnerName || this.partnerUser || this.category || this.approverEmail || this.approvalStatus) {
        this.closeIconFlag = true;
        this.runSearch();
      }
    }
  }

  runSearch() {
    const req = 'activityChallengeId=' + this.activityId + '&page=' + (this.page - 1) + '&size=' + this.size +
      '&partnerName=' + this.partnerName + '&partnerUser=' + this.partnerUser +
      '&category=' + this.category + '&email=' + this.approverEmail + '&status=' + this.approvalStatus;
    this.approverService.getApprovalListBySearch(req).subscribe(res => {
      this.approverList = res;
    }, (error) => {
      console.log(error);
    });
  }

  onClearSearch() {
    this.clearSearch();
    this.loadData();
  }

  clearSearch() {
    this.partnerName = '';
    this.partnerUser = '';
    this.category = '';
    this.approverEmail = '';
    this.approvalStatus = '';
    this.selectedApprovalStatusItem = null;
    this.closeIconFlag = false;
    this.searchDiv = false;
    this.searchCount = 0;
  }

  downloadFile(url: string) {
    const win = window.open(url, '_blank');
    if (win) { win.focus(); }
  }

  onApproveClick(row: any) {
    this.openApprove.emit(row);
  }

  onRejectClick(row: any) {
    this.openReject.emit(row);
  }

  onChatClick(row: any) {
    this.openChat.emit(row);
  }
}
